import { render, staticRenderFns } from "./_serviceId.vue?vue&type=template&id=385db0b4"
import script from "./_serviceId.vue?vue&type=script&lang=js"
export * from "./_serviceId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports